var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteButtonBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02509 3.13445L2.7322 2.42735L6.97484 6.66999L6.26773 7.3771L2.02509 3.13445Z",
    fill: "#2671D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26773 2.42735L6.97484 3.13445L2.7322 7.3771L2.02509 6.66999L6.26773 2.42735Z",
    fill: "#2671D1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButtonBlue);
export default __webpack_public_path__ + "static/media/delete_button_blue.f94758ea38d286a30ef5b9f0bc94000e.svg";
export { ForwardRef as ReactComponent };